<template>
    <app-modal modal-id="role-export-modal" modal-size="large" modalAlignment="top" @close-modal="closeModal">
        <div class="modal-header">
            <h4 class="modal-title">{{ $t('export') }}</h4>
            <button type="button" class="close outline-none" aria-label="Close" data-dismiss="modal" @click="closeModal">
                <span><app-icon name="x"></app-icon></span>
            </button>
        </div>
        <div class="modal-body custom-scrollbar">
            <form class="mb-0" ref="form" enctype="multipart/form-data">
                <div>
                    <div class="note-title d-flex">
                        <app-icon name="book-open" />
                        <h6 class="card-title pl-2">{{ $t("remember") }}</h6>
                    </div>
                    <div class="note note-warning p-4 mb-2">
                        <ol style="list-style: none;">
                            <li class="my-1"> {{ $t("csv_export_guide1") }}</li>
                        </ol>
                    </div>

                    <div class="my-primary">
                        <label for="fields">{{ $t('select_type') }}</label>
                        <div class="d-flex flex-column g-1">
                            <app-input v-model="formData.all" type="checkbox"
                                :list="[{ id: 'all_data', value: $t('all_data') }]" radioCheckboxWrapper="d-flex g-1"
                                @changed="allChange" />
                            <hr>
                            <app-input v-model="formData.fields" type="checkbox" :list="list"
                                radioCheckboxWrapper="custom-input-wrapper" @input="inputListValue" />
                        </div>
                    </div>
                </div>
            </form>
            <div class="note note-warning d-inline-block p-3 mb-primary">
                <div class="d-flex --justify-content-center gap-2">
                    <div class="d-flex align-items-center">
                        <span class="d-flex px-3 py-2 form-control">{{ equation.field1 }}</span>
                        <span class="d-flex px-3 py-2 --form-control">+</span>
                        <span class="d-flex px-3 py-2 form-control">{{ equation.field2 }}</span>
                    </div>
                    <span class="d-flex px-3 py-2">=</span>
                    <input type="text" class="form-control" v-model="equation.result" :placeholder="$t('answer')"
                        style="width: 80px;">
                </div>
            </div>
            <div class="text-right">
                <button class="btn btn-secondary" data-dismiss="modal" @click.prevent="closeModal">{{
                    $t('no') }}</button>
                <button class="btn btn-primary" @click.prevent="confirm"
                    :disabled="preloader || !([...formData.all, ...formData.fields].length) || ((equation.field1 + equation.field2)?.toString() !== equation.result?.toString())">{{
                        $t('export') }} </button>
            </div>
        </div>
    </app-modal>
</template>

<script>
import { FormMixin } from "../../../core/mixins/form/FormMixin";
import { EXPORT_MODULES } from "../../../tenant/Config/ApiUrl";
import { axiosPost } from "../../Helper/AxiosHelper";
import { localTimeZone } from "../../Helper/Support/DateTimeHelper";

export default {
    mixins: [FormMixin],
    data() {
        return {
            list: [
                { id: 'holiday', value: this.$t('modules_holiday') },
                { id: 'leave_type', value: this.$t('modules_leave_type') },
                { id: 'employee', value: this.$t('modules_employee') },
                { id: 'employment_history', value: this.$t('modules_employment_history') },
                { id: 'designation_history', value: this.$t('modules_designation_history') },
                { id: 'department_history', value: this.$t('modules_department_history') },
                { id: 'work_shift', value: this.$t('modules_work_shift') },
                { id: 'attendance', value: this.$t('modules_attendance') },
                { id: 'leave', value: this.$t('modules_leave') },
                { id: 'salary_history', value: this.$t('modules_salary_history') },
                { id: 'department', value: this.$t('department') },
            ],
            formData: {
                fields: [
                    'holiday',
                    'leave_type',
                    'employee',
                    'employment_history',
                    'designation_history',
                    'department_history',
                    'work_shift',
                    'attendance',
                    'leave',
                    'salary_history',
                    'department',
                ], all: ['all_data']
            },
            equation: { field1: this.randomValue(1, 10), field2: this.randomValue(1, 10), result: '' },
            preloader: false,
        }
    },
    methods: {
        randomValue(min, max) {
            return Math.round(Math.random() * (max - min) + min);
        },
        allChange(e) {
            if (e.target.checked) {
                this.formData.fields = this.list.map(i => i.id)
            } else {
                this.formData.fields = []
            }
        },
        inputListValue(e) {
            let allList = !!(!this.list.map(i => i.id).filter(i => !e.includes(i)).length)
            if (allList) {
                this.formData.all = ['all_data']
            } else {
                this.formData.all = []
            }
        },
        confirm() {
            this.preloader = true;
            axiosPost(EXPORT_MODULES + '?timeZone=' + localTimeZone, { fields: [...this.formData.all, ...this.formData.fields] }).then(({ data }) => {
                this.$toastr.s(data.message);
                this.closeModal()
            }).catch(({ response }) => {
                console.log('err', response)
                this.$toastr.e(response.data.message);
            }).finally(() => {
                this.preloader = false;
            })
        },
        closeModal() {
            $('#role-export-modal').modal('hide');
            this.$emit('close');
        },
    },
    mounted() {
        $('#role-export-modal').modal('show')
    }
};
</script>

<style>
.custom-input-wrapper {
    display: grid;
    grid-template-columns: auto auto auto;
    gap: 10px;
}
</style>
